import React, { useEffect, useState } from "react";
import "./Planner.scss";
import $ from "jquery";
import NewPlanner from "./NewPlanner";
import { connect } from "react-redux";
import { getAllChapters, submitPlanner, getPlanners } from "../../../actions/tutorFeedActions"
import { monthNames, successColor } from "../../../actions/utility";
import ArchivedPlanner from "./ArchivedPlanner";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const Planner = (props) => {
  const [programNameState, setprogramNameState] = useState();
  const [programId, setprogramId] = useState("");
  const [loading, setloading] = useState(false);
  const [simulatorData, setsimulatorData] = useState([]);
  const [clientId, setclientId] = useState("");
  const [loggedUserId, setloggedUserId] = useState("");
  const [planners, setplanners] = useState([]);
  const [month, setmonth] = useState(monthNames[new Date().getMonth()]);
  const [year, setyear] = useState(new Date().getFullYear().toString());
  const [viewPlanner, setviewPlanner] = useState(false);
  const [selectedPlannerId, setselectedPlannerId] = useState("");
  const [snackbarColor, setsnackbarColor] = useState(successColor);
  const [snackbarMessage, setsnackbarMessage] = useState("Planner Generated Successfully");
  const [snackbar, setsnackbar] = useState(false);
  const [newPlanner, setnewPlanner] = useState(false);
  const [modal, setModal] = useState(false);
  const [slotId, setslotId] = useState("");
  const toggle = () => setModal(!modal);

  useEffect(() => {
    getAllPlannersFunction();
  }, [])

  useEffect(() => {
    $(".collapse")
      .on("shown.bs.collapse", function () {
        $(this)
          .parent()
          .find(".fa-plus")
          .removeClass("fa-plus")
          .addClass("fa-minus");
      })

      .on("hidden.bs.collapse", function () {
        $(this)
          .parent()
          .find(".fa-minus")
          .removeClass("fa-minus")
          .addClass("fa-plus");
      });
  });


  useEffect(() => {
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    if (tutorData != null) {
      setclientId(tutorData.user.client_id);
      setloggedUserId(tutorData.user.id);
    }
  }, [])


  const getAllPlannersFunction = () => {
    debugger;
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    if (tutorData != null) {
      props.getPlanners(tutorData.user.id, tutorData.user.client_id);
    }
  }

  const submitPlannerFunc = () => {
    debugger;
    setsnackbarColor(successColor);
    setsnackbarMessage("Planner Generated Successfully");
    setModal(false);
    props.submitPlanner(clientId, loggedUserId, programId, month, year, simulatorData ,slotId)
      .then((res) => {
        if (res.status === 200) {
          getAllPlannersFunction();
          setnewPlanner(true);
          setsnackbar(true);
          setTimeout(function () {
            setsnackbar(false);
          }, 3000);

        }
        debugger;
        console.log(res)
      })
  }

  if (props.programNameState.programName !== programNameState) {
    const { programNameState } = props;
    setloading(true)
    setprogramNameState(programNameState.programName);
    setprogramId(programNameState.program);
    setslotId(programNameState.slotId);
    debugger;

    props.getAllChapters(programNameState.program)

  }

  if (props.allPlanners.response !== planners) {
    debugger;
    const { allPlanners } = props;

    setplanners(allPlanners.response);
    debugger;

  }

  const onchangePlanner = (id) => {
    const filterPlanner = planners.filter(item => item.planner_id === id);
    setsimulatorData(JSON.parse(filterPlanner[0]["week_data"]))
    setviewPlanner(true)
    setselectedPlannerId(id);
    console.log("Simulator Data", simulatorData);

  }

  const simulatorDataChange = (e, topicId, itemName, itemid, chapterId, chapterName) => {
    const { programNameState } = props;
    if (e.target.checked) {
      simulatorData.push({
        id: itemid,
        week: e.target.value,
        topicName: itemName,
        topicId: topicId,
        chapterId: chapterId,
        chapterName: chapterName,
        programId: programNameState.program,
        programName: programNameState.programName,
      })
      setsimulatorData([...simulatorData]);
    }
    else {
      const filterSimulator = simulatorData.filter(item => item.id !== itemid);
      setsimulatorData(filterSimulator);
    }
    console.log("Simulator Data", simulatorData);
  }

  const onHandleTextChange = e => {
    if (e.target.name === "month") {
      setmonth(e.target.value);
    }
    else if (e.target.name === "year") {
      setyear(e.target.value);
    }
  }

  const resetNewPlanner = () => {
    setsimulatorData([])
    setviewPlanner(false)
  }

  const onClickArchivedPlanner = () => {
    setsimulatorData([]);
    setnewPlanner(false);
  }
  console.log("Month", month)
  console.log("Planners", planners)
  return (
    <div className="row TabsForPlanner">
      <div className={snackbar ? "show" : ""} id="snackbar" style={{ backgroundColor: snackbarColor }}>{snackbarMessage}</div>
      <div className="col-md-8">
        <div className="">

          <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item">
              <a
                className="nav-link active"
                data-toggle="tab"
                href="#tabs-1"
                role="tab"
                onClick={resetNewPlanner}
              >
                New Planner
          </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tabs-2" role="tab" onClick={onClickArchivedPlanner}>
                Archived Planner {newPlanner ? <span>1</span> : null}
              </a>
            </li>
          </ul>
          <div className="tab-content">
            <div className="tab-pane active" id="tabs-1" role="tabpanel">

              <NewPlanner programId={programId} simulatorDataChange={simulatorDataChange} onHandleTextChange={onHandleTextChange} showLoader={loading}/>

            </div>

            <div className="tab-pane" id="tabs-2" role="tabpanel">

              <ArchivedPlanner allPlanners={planners} onchangePlanner={onchangePlanner} selectedPlannerId={selectedPlannerId} />

            </div>
          </div>
        </div>
      </div>
      {simulatorData.length > 0 ?
        <div className="col-md-4">
          <div className="p-2 shadow-sm simulator animated slideInDown">
            <h5>Week 1:</h5>
            {simulatorData.map((item, index) => {
              if (item.week === "1") {
                return (
                  <div>
                    <label className="animated fadeInDown mb-0">{item.topicName}</label>
                    <p
                      className="text-italic"
                      style={{ fontSize: 12, color: "#c1c1c1" }}
                    >
                      (Chapter: {item.chapterName})
                    </p>
                  </div>
                )
              }
            }
            )}
            <hr />
            <h5>Week 2:</h5>
            {simulatorData.map((item, index) => {
              if (item.week === "2") {
                return (
                  <div>
                    <label className="animated fadeInDown mb-0">{item.topicName}</label>
                    <p
                      className="text-italic"
                      style={{ fontSize: 12, color: "#c1c1c1" }}
                    >
                      (Chapter: {item.chapterName})
                    </p>
                  </div>
                )
              }
            }
            )}
            <hr />
            <h5>Week 3:</h5>
            {simulatorData.map((item, index) => {
              if (item.week === "3") {
                return (
                  <div>
                    <label className="animated fadeInDown mb-0">{item.topicName}</label>
                    <p
                      className="text-italic"
                      style={{ fontSize: 12, color: "#c1c1c1" }}
                    >
                      (Chapter: {item.chapterName})
                    </p>
                  </div>
                )
              }
            }
            )}
            <hr />
            <h5>Week 4:</h5>
            {simulatorData.map((item, index) => {
              if (item.week === "4") {
                return (
                  <div>
                    <label className="animated fadeInDown mb-0">{item.topicName}</label>
                    <p
                      className="text-italic"
                      style={{ fontSize: 12, color: "#c1c1c1" }}
                    >
                      (Chapter: {item.chapterName})
                    </p>
                  </div>
                )
              }
            }
            )}
            {viewPlanner ? null :
              <button className="generateBtn btn-block" onClick={toggle}>Generate Planner</button>
            }
          </div>
        </div>
        : null}
      <div>
        <Modal isOpen={modal} toggle={toggle} centered size="md" className="modalModal" backdrop={true}>
          <ModalHeader className="modalHeaderStyle" toggle={toggle}>Generate Planner</ModalHeader>
          <ModalBody className="modalHeaderStyle">
            Do you want to Generate Planner for {programNameState} for the month of {month}?
            <br />
            <br />
            We will send the Planner via Email.
        </ModalBody>
          <ModalFooter className="modalHeaderStyle">
            <Button color="success" onClick={submitPlannerFunc}>Generate and Send</Button>
            <Button color="secondary" onClick={toggle}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    programNameState: state.feedTutorRed.programName,
    attendanceData: state.feedTutorRed.attendanceData,
    allPlanners: state.feedTutorRed.allPlanners
  };
}
export default connect(mapStateToProps, { getAllChapters, submitPlanner, getPlanners })(Planner);